import { render, staticRenderFns } from "./VehiclesForm.vue?vue&type=template&id=04173847&"
import script from "./VehiclesForm.vue?vue&type=script&lang=js&"
export * from "./VehiclesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports